import React from "react";

export const SmartphoneLandscape = () => {
    return (<div className="sp-landscape">
        <div className="sp-landscape__content">
            <img className='sp-landscape__img' src="img/sp/smartphone-vertical.png" alt=""/>
            <div className='sp-landscape__text-1'>Please make your smartphone vertical.</div>
            <div className='sp-landscape__text-2'>スマートフォンを縦にしてください。</div>
        </div>
    </div>);
};